<template>
  <svg viewBox="0 0 36 36">
    <path
      class="circle-bg"
      d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
    />
    <path
      class="circle"
      v-if="perc > 0"
      v-bind:stroke-dasharray="perc+', 100'"
      d="M18 2.0845
        a 15.9155 15.9155 0 0 1 0 31.831
        a 15.9155 15.9155 0 0 1 0 -31.831"
    />
  </svg>
</template>

<script>
export default {
  name: 'progressCircle',
  props: {
    perc: { type: String }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/partials/progress-circle.vue